<div class="accuracy-tiers mb-4" [ngClass]="{'disabled':disabled}">
    <div class="tier-container-contacts flex justify-center" *ngIf="view === 'contacts'; else companies">
        <div class="tier-group flex relative">
            <div class="outer-circle relative cursor-pointer"
                [class.toggled]="accuracy_tier | isIncluded:['MV']"
                [class.cursor-default]="!allowMVAccuracySelection"
                (click)="onContactsChange($event, 'MV')"
                [matTooltip]="allowMVAccuracySelection ? 'Machine verified contacts use our machine-learning engine to verify contact details.' : MVAccuracyNotAllowedTooltipText" matTooltipPosition="above">
                <div class="inner-circle"></div>
                <span class="absolute">Machine Verified</span>
            </div>
            <div class="line" [class.bold]="accuracy_tier | isIncluded:['MV']"></div>
            <div class="outer-circle relative cursor-pointer"
                [class.toggled]="accuracy_tier | isIncluded:['MV', 'EV', '']"
                (click)="onContactsChange($event, 'EV')"
                matTooltip="Email verified contacts have their primary email address verified by our researchers." matTooltipPosition="above">
                <div class="inner-circle"></div>
                <span class="absolute">Email Verified</span>
            </div>
            <div class="line" [class.bold]="accuracy_tier | isIncluded:['MV', 'EV', '']"></div>
            <div class="outer-circle relative toggled" (click)="onContactsChange($event, 'HV')"
                matTooltip="Human verified contacts are reverified by our researchers every 90 days." matTooltipPosition="above">
                <div class="inner-circle"></div>
                <span class="absolute">Human Verified</span>
            </div>
        </div>
    </div>

    <ng-template #companies>
        <div class="tier-container-companies flex">
            <div class="tier-group tier-group-companies flex">
                <div class="outer-circle relative cursor-pointer"
                    [class.toggled]="accuracy_tier | isIncluded:['MV', '']"
                    (click)="onCompaniesChange($event, 'MV')"
                    matTooltip="Machine verified companies use public and private data sets to verify account details." matTooltipPosition="above">
                    <div class="inner-circle"></div>
                    <span class="absolute">Machine Verified</span>
                </div>
                <div class="line" [class.bold]="accuracy_tier | isIncluded:['MV', '']"></div>
                <div class="outer-circle relative toggled" (click)="onCompaniesChange($event, 'HV')"
                    matTooltip="Human verified companies have firmographics confirmed by our Research Team." matTooltipPosition="above">
                    <div class="inner-circle"></div>
                    <span class="absolute">Human Verified</span>
                </div>
            </div>
        </div>
    </ng-template>
</div>
